import { render } from "./EditablePage.vue?vue&type=template&id=6b481784"
import script from "./EditablePage.vue?vue&type=script&lang=js"
export * from "./EditablePage.vue?vue&type=script&lang=js"

import "./EditablePage.vue?vue&type=style&index=0&id=6b481784&lang=css"
script.render = render

export default script